import { mdiCheckboxBlankCircleOutline } from "@mdi/js";

const themeConfig = {
  app: {
    name: "Corporativo",
    // logo: require("@/assets/images/svg/logo.svg"),
    logo: require("@/assets/Ridery360Logo.png"),
    logoLarge: require("@/assets/Ridery360.png"),
    isDark: false,
    isRtl: false,
    contentLayoutNav: "vertical", // vertical, horizontal
    routeTransition: "scroll-x-transition", // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: "semi-dark", // default, bordered, semi-dark
    contentWidth: "boxed",
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: "fixed", // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: "static", // fixed, static, hidden
  },
  themes: {
    light: {
      primary: "#000522",
      accent: "#EF4370",
      secondary: "#000522",
      success: "#3BD4AE",
      info: "#244074",
      blue: "#2196F3",
      warning: "#FFB400",
      error: "#EF4370",
      white: "#FFFFFF",
      gray: "#555A65",
      panita: "#25D366",
      lightGray: "#F5F5F5",
    },
    dark: {
      primary: "#3BD4AE",
      accent: "#244074",
      secondary: "#3BD4AE",
      success: "#3BD4AE",
      info: "#244074",
      blue: "#2196F3",
      warning: "#FFB400",
      error: "#EF4370",
      white: "#312d4b",
      gray: "#555A65",
      panita: "#25D366",
      lightGray: "#F5F5F5",
    },
  },
};

export default themeConfig;
